import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody51';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy51 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;transform:scale(0.85);transform-origin:left;'>Reporting Automation</h2>";

  return (
    <>
        <Helmet>
        <title>Reporting Automation</title>
        <meta property="og:title" content="Reporting Automation" />
        <meta property='og:description' content='Reporting Automation'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy51" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy51
